var renderEdvisorSearchModal = function renderEdvisorSearchModal(_ref) {
  var defaultCourseCategoryIds = _ref.defaultCourseCategoryIds,
      defaultGooglePlaceId = _ref.defaultGooglePlaceId,
      schoolIds = _ref.schoolIds;
  var integerCourseCategoryIds = defaultCourseCategoryIds === null || defaultCourseCategoryIds === void 0 ? void 0 : defaultCourseCategoryIds.map(function (id) {
    return id ? parseInt(id, 0) : undefined;
  });
  var listOfSchoolIds = schoolIds === null || schoolIds === void 0 ? void 0 : schoolIds.split(',');
  var script = document.createElement('script');
  script.src = 'https://cdn.edvisor.io/b2c/sandbox/edvisor-search.js';
  script.async = true;

  script.onload = function () {
    // @ts-ignore
    var edvisorInstance = window.Edvisor.widgets.StartQuoteModal.newInstance({
      agencyId: 2924,
      apiKey: 'public_79138f1666c24b1b132fa81cc5fe6153',
      defaultCourseCategoryIds: integerCourseCategoryIds,
      defaultGooglePlaceIds: [defaultGooglePlaceId],
      defaultSchoolIds: listOfSchoolIds,
      redirectUrl: typeof window !== 'undefined' ? window.location.origin + '/devis-en-ligne' : '',
      searchBySchool: false,
      startQuoteSelector: '#btWidget',
      studentLanguage: 'fr',
      studentNationality: 'be'
    });
    edvisorInstance.render();
  };

  document.body.appendChild(script);
};

export default renderEdvisorSearchModal;